<ion-header #header>
    <ion-toolbar #toolbar>
        <ion-buttons slot="primary">
            <ion-button appClick (clicked)="onClose()" #menuButton id="mainmenu-menu-button">Abbrechen</ion-button>
        </ion-buttons>
        <ion-title><span id="page-title-span">{{ 'Adressen' | translate }}</span></ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="app-content">

    <ion-searchbar [(ngModel)]="suchtext"
                   (ionChange)="onSearchChanged()"
                   (ionInput)="onSearchInput()"
                   (ionClear)="onSearchCleared()"
                   enterkeyhint="search"
                   [debounce]="1000"
                   placeholder="{{ 'Suchen' | translate }}"
                   #searchbar></ion-searchbar>

    <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <cdk-virtual-scroll-viewport *ngIf="sichtbareItems.length" [itemSize]="48" minBufferPx="900" maxBufferPx="1350" class="ion-content-scroll-host">
        <ion-list>
            <div *cdkVirtualFor="let item of sichtbareItems; let index = index;">
                <ion-item class='artikelitem' appClick (clicked)="onItemSelected(item)">
                    <ion-label class="row-item-label">
                        <ion-icon *ngIf="item.istFavorit" name="star" class="favorit-icon"></ion-icon>
                        <h2>{{ item.adresse.Name1 }}</h2>
                        <div>{{ item.adresse.Name2 }}</div>
                        <div>{{ item.adresse.Strasse }}</div>
                        <div>{{ item.adresse.PLZ }} {{ item.adresse.Ort }}</div>
                        <div *ngIf="item.entfernungText" class="entfernung">{{ item.entfernungText }}</div>
                        <div>AdressKey: {{ item.adresse.AdressNummer }}</div>
                        <!-- <div class="vtext">{{ item.adresse.Text }}</div> -->
                    </ion-label>
                </ion-item>
            </div>
        </ion-list>
    </cdk-virtual-scroll-viewport>

    <div *ngIf="!sichtbareItems.length && leerText" class="leer-text">
        {{ leerText | translate }}
    </div>

</ion-content>